import { InteractableObject, ObjectInteractionMap, InteractionTypeEnum } from '../types/portfolio_types'
import { getAppleData } from '../store/localstorageData'

const mushroom_house_object_interactions: ObjectInteractionMap = {
  desk: {
    inspect: {
      id: 'inspect',
      type: InteractionTypeEnum.dialog,
      dialog: [
        {
          id: 'inspect_desk_1',
          text: `There's code on the monitor, and the notebook has a few to-do points written on it.`,
        },
        {
          id: 'inspect_desk_2',
          text: `Some character doodles decorate the pages as well.`,
        },
      ],
    },
  },
  bed: {
    inspect_not_having_picked_apple: {
      id: 'not_picked_apple',
      type: InteractionTypeEnum.dialog,
      dialog: [
        {
          id: 'inspect_bed_1',
          text: `I wonder if there's something under this bed...`,
        },
        {
          id: 'inspect_bed_2',
          text: `Oh!`,
        },
      ],
    },
    inspect_having_picked_apple: {
      id: 'picked_apple',
      type: InteractionTypeEnum.dialog,
      dialog: [
        {
          id: 'inspect_bed_1',
          text: `It's just a normal bed, and there are no more apples under it.`,
        },
      ],
    },
  },
  mysterious_door: {
    inspect: {
      id: 'inspect',
      type: InteractionTypeEnum.dialog,
      dialog: [
        {
          id: 'inspect_mysterious_door',
          text: `It's locked.`,
        },
      ],
    },
  },
  house_exit: {
    inspect: {
      id: 'inspect',
      type: InteractionTypeEnum.animation,
    },
  },
}

const interactable_mushroom_room_objects: { [key: string]: InteractableObject } = {
  sensor_desk: {
    id: 'sensor_desk',
    inspect_word: 'Inspect',
    focus_on_contact: false,
    interactions: mushroom_house_object_interactions.desk,
  },
  sensor_bed: {
    id: 'sensor_bed',
    inspect_word: 'Inspect',
    on_inspect_animation: 'bianca_inspecting_rabbit_hole',
    focus_on_contact: false,
    interactions: mushroom_house_object_interactions.bed,
    determineInteraction: () => {
      const apple_data = getAppleData()

      if (apple_data.list.apple020) {
        return 'inspect_having_picked_apple'
      }

      return 'inspect_not_having_picked_apple'
    },
  },
  sensor_mysterious_door: {
    id: 'sensor_mysterious_door',
    inspect_word: 'Inspect',
    skip_setting_position: true,
    focus_on_contact: false,
    interactions: mushroom_house_object_interactions.mysterious_door,
  },
  sensor_house_exit: {
    id: 'sensor_house_exit',
    inspect_word: 'Exit',
    skip_setting_position: true,
    focus_on_contact: false,
    interactions: mushroom_house_object_interactions.house_exit,
  },
}

export { interactable_mushroom_room_objects }
